import { useContext } from "react";
import { Typography } from "@material-ui/core";
import { BookingContext } from "../../providers/BookingProvider";
import { getTotalPriceOfServiceWithPatients } from "../../utils/pricesService";

const BookingSummary = () => {
  const { booking, organization } = useContext(BookingContext);
  let total = 0.0;
  let servicesCost = 0.0;
  let totalHomeServiceCost = 0.0;
  if (booking.patients && booking.patients.length > 0) {
    // including additional patients costs
    [servicesCost, totalHomeServiceCost, total] =
      getTotalPriceOfServiceWithPatients(
        booking.products.reduce((acc, el) => acc + el.price, 0),
        booking.patients.length,
        booking.products.reduce((acc, el) => acc + el.servicePrice, 0),
        organization,
        booking.discount
      );
  }

  return (
    <div
      style={{
        borderRadius: 16,
        backgroundColor: "#FFF",
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        maxHeight: "70vh",
        overflowY: "auto",
      }}
    >
      <div
        style={{
          backgroundColor: "#CCD7EE",
          borderRadius: "16px 16px 0px 0px",
          padding: "1.5rem",
          textAlign: "center",
        }}
      >
        <Typography
          variant={"h6"}
          style={{ color: "#4E5C93", fontWeight: "bold" }}
        >
          Mi reserva
        </Typography>
      </div>
      <div style={{ padding: "3rem", color: "#4E5C93" }}>
        {/* product */}
        <Typography style={{ padding: "6px 0" }}>
          Productos solicitados:
        </Typography>
        {booking?.products.map((product) => (
          <>
            <Typography
              style={{ padding: "6px 0", color: "#6A6D81" }}
              variant={"body2"}
            >
              {product.name}
            </Typography>

            <Typography
              style={{ padding: "6px 0", color: "#6A6D81" }}
              variant={"body2"}
            >
              - $ {product.price}
            </Typography>
          </>
        ))}

        {/* service */}
        <Typography style={{ padding: "6px 0" }}>
          Servicios solicitados asociados:
        </Typography>

        {booking?.products.map((product) => (
          <>
            <Typography
              style={{ padding: "6px 0", color: "#6A6D81" }}
              variant={"body2"}
            >
              {product.serviceName}
            </Typography>
            <Typography
              style={{ padding: "6px 0", color: "#6A6D81" }}
              variant={"body2"}
            >
              - ${product.servicePrice}
            </Typography>
          </>
        ))}

        <Typography style={{ padding: "6px 0" }}>Día :</Typography>
        <Typography
          style={{ padding: "6px 0", color: "#6A6D81" }}
          variant={"body2"}
        >
          {booking?.date}
        </Typography>
        <Typography style={{ padding: "6px 0" }}>Franja horaria:</Typography>
        <Typography
          style={{ padding: "6px 0", color: "#6A6D81" }}
          variant={"body2"}
        >
          {booking?.time?.label}
        </Typography>
        <Typography style={{ padding: "6px 0" }}>Comuna:</Typography>
        <Typography
          style={{ padding: "6px 0", color: "#6A6D81" }}
          variant={"body2"}
        >
          {booking?.location?.name}
        </Typography>
        {total > 0.0 && (
          <>
            <hr />

            {/* product cost */}
            <Typography
              style={{ padding: "6px", fontWeight: "bold" }}
              variant={"body2"}
            >
              Precio producto:
            </Typography>
            <Typography
              style={{ padding: "6px", color: "#6A6D81" }}
              variant={"body2"}
            >
              ${servicesCost}
            </Typography>

            {/* services cost */}
            <Typography
              style={{ padding: "6px", fontWeight: "bold" }}
              variant={"body2"}
            >
              Precio de servicio asociado:
            </Typography>
            <Typography
              style={{ padding: "6px", color: "#6A6D81" }}
              variant={"body2"}
            >
              ${totalHomeServiceCost}
            </Typography>

            {/* discount */}
            {booking.discount !== undefined && booking.discount !== 0 && (
              <>
                <Typography
                  style={{ padding: "6px", fontWeight: "bold" }}
                  variant={"body2"}
                >
                  Descuento aplicado 😍
                </Typography>
                <Typography
                  style={{ padding: "6px", color: "#6A6D81" }}
                  variant={"body2"}
                >
                  ${booking.discount}
                </Typography>
              </>
            )}
            {/* total cost */}
            <Typography
              style={{ padding: "6px", fontWeight: "bold" }}
              variant={"body2"}
            >
              Total a pagar:
            </Typography>
            <Typography
              style={{ padding: "6px", color: "#6A6D81" }}
              variant={"body2"}
            >
              ${total}
            </Typography>
          </>
        )}
      </div>
    </div>
  );
};

export default BookingSummary;
